import React from 'react';
import useSceneStore from '../store/useSceneStore';
import { TOOLS, ELEMENT_TYPES } from '../core/constants';
import SafeIcon from '../common/SafeIcon';
import { RiDoorClosedLine, RiDoorOpenLine, RiDoorLine, RiRoundedCorner, RiSplitCellsHorizontal } from "react-icons/ri";
import { LuRectangleEllipsis } from "react-icons/lu";
import { clsx } from 'clsx';

const OPENING_TYPES = [
  { id: ELEMENT_TYPES.DOOR, name: 'Drzwi', icon: RiDoorClosedLine },
  { id: ELEMENT_TYPES.DOUBLE_DOOR, name: 'Drzwi dwuskrzydłowe', icon: RiDoorOpenLine },
  { id: ELEMENT_TYPES.SLIDING_DOOR, name: 'Drzwi przesuwne', icon: RiSplitCellsHorizontal },
  { id: ELEMENT_TYPES.WINDOW, name: 'Okno', icon: RiDoorLine },
  { id: ELEMENT_TYPES.OPENING, name: 'Przejście', icon: RiRoundedCorner },
  { id: ELEMENT_TYPES.GARAGE_DOOR, name: 'Brama garażowa', icon: LuRectangleEllipsis },
];

const OpeningCatalogPanel = () => {
  const { tool, setTool } = useSceneStore();

  // Panel jest widoczny gdy aktywne jest narzędzie OPENINGS lub konkretny typ otworu
  const isOpeningTool = Object.values(ELEMENT_TYPES).includes(tool);
  if (tool !== TOOLS.OPENINGS && !isOpeningTool) return null;

  return (
    <div className="absolute left-20 bottom-4 w-64 bg-white rounded-xl shadow-lg border border-gray-200 flex flex-col overflow-hidden z-10">
      {/* Header */}
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200">
        <h3 className="font-semibold text-gray-700 text-sm">Drzwi i Okna</h3>
      </div>

      {/* Items List */}
      <div className="p-3 grid grid-cols-1 gap-2 max-h-96 overflow-y-auto">
        {OPENING_TYPES.map((item) => (
          <button
            key={item.id}
            onClick={() => setTool(item.id)}
            className={clsx(
              "flex items-center gap-3 p-3 rounded-lg transition-all border-2 text-left",
              tool === item.id 
                ? "border-[#1E2937] bg-gray-50 shadow-sm" 
                : "border-transparent hover:bg-gray-50 hover:border-gray-100"
            )}
          >
            <div className={clsx(
              "p-2 rounded-lg",
              tool === item.id ? "bg-[#1E2937] text-white" : "bg-gray-100 text-gray-600"
            )}>
              <SafeIcon icon={item.icon} className="text-xl" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-900">{item.name}</div>
              <div className="text-xs text-gray-500">Kliknij aby wstawić</div>
            </div>
          </button>
        ))}
      </div>

      {/* Footer Info */}
      <div className="bg-gray-50 px-4 py-2 border-t border-gray-200">
        <div className="text-xs text-gray-500 text-center">
          Wybierz typ i kliknij na ścianę
        </div>
      </div>
    </div>
  );
};

export default OpeningCatalogPanel;